import { useMemo } from 'react';
import useOrganizationStore, {
  OrganizationStore,
} from '../store/organizationStore';

// The tenant list itself is fetched once by RequireLogin (public endpoint,
// needed before any gated content renders); this hook only reads the store.
const useOrganizations = (): Omit<OrganizationStore, 'setOrgs'> => {
  const { list, lookup } = useOrganizationStore();

  return useMemo(() => {
    return { list, lookup };
  }, [list, lookup]);
};

export default useOrganizations;
